import Header from "./Header";
import MainPage from "./MainPage";
import RecentProjects from "./RecentProjects";
import Short from "./Short";
import AboutMeSec from "./AboutMeSec";
import { useLoading } from "../contexts/DisplayLoading";
export default function Home() {
  let { loading, DisplayLoading } = useLoading();
  DisplayLoading();
  return (
    <div style={{ backgroundColor: loading.isVisible ? "black" : "white" }}>
      <div
        style={{
          height: "100vh",
          backgroundColor: "#999D9E",
          width: "100%",
          position: "relative",
          display: loading.isVisible ? "none" : "block",
        }}
      >
        <div>
          <div style={{ height: "100vh", overflow: "hidden" }}>
            <Header
              headerColor="white"
              hoverColor="white"
              shadowColor="white"
            />
            <MainPage />
          </div>
          <div>
            <Short />
            <RecentProjects />
            <AboutMeSec />
          </div>
        </div>
      </div>
    </div>
  );
}
